


























import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Achat} from '@/models';

import CrudAchatList from '@/components/Crud/Achat/ListEncours.vue';

@Component({
	components: {
		CrudAchatList,
	}
})
export default class AchatEncoursView extends Vue {

}
